import i18n from '../../../i18n'

export const ASSET_TABS = {
    TAB_MY_LIBRARY: 'TAB_MY_LIBRARY',
    TAB_UNSPLASH_LIBRARY: 'TAB_UNSPLASH_LIBRARY',
    TAB_GIPHY: 'TAB_GIPHY',
}

export const SORT_TABS = {
    SORT_TAB_ALL: 'SORT_TAB_ALL',
    SORT_TAB_THIS_PROJECT: 'SORT_TAB_THIS_PROJECT',
    SORT_TAB_UNSPLASH: 'SORT_TAB_UNSPLASH',
    SORT_TAB_GIPHY: 'SORT_TAB_GIPHY',
    SORT_TAB_VIDEO: 'SORT_TAB_VIDEO',
}

export const SIZE_IMAGES = {
    SMALL: 'SMALL',
    TINY: 'TINY',
    ORIGINAL: 'ORIGINAL',
    NORMAL: 'NORMAL',
    NORMAL2X: 'NORMAL2X',
}

export const UPLOAD_STATUS = {
    prepare: 'prepare',
    ok: 'ok',
    error: 'error',
}

export const ASSET_TABS_LABELS = {
    [ASSET_TABS.TAB_MY_LIBRARY]: i18n.t('My library'),
    [ASSET_TABS.TAB_UNSPLASH_LIBRARY]: i18n.t('Unsplash library'),
    [ASSET_TABS.TAB_GIPHY]: i18n.t('Giphy library'),
}

export const SORT_TAB_LABELS = {
    [SORT_TABS.SORT_TAB_ALL]: i18n.t('All'),
    [SORT_TABS.SORT_TAB_THIS_PROJECT]: i18n.t('This project'),
    [SORT_TABS.SORT_TAB_UNSPLASH]: i18n.t('Unsplash'),
    [SORT_TABS.SORT_TAB_GIPHY]: i18n.t('Giphy'),
    [SORT_TABS.SORT_TAB_VIDEO]: i18n.t('Video'),
}
